import initVideoControl from "./scripts/video";
import applyPatternlabFixes from "./scripts/pl-fixes";

const initGlobalScripts = () => {
    initVideoControl();
    applyPatternlabFixes();
};

export default initGlobalScripts;
